package com.essntl.uikit.components.chat.conversation

data class ConversationFilterOptions(
    val searchText: String = "",
    val selectedSource: String = "All",
    val selectedSender: String = "All",
    val recentFirst: Boolean = true,
    val unreadFirst: Boolean = false,
)
